module.exports = __webpack_public_path__ + "static/media/00040800.5aa0f189.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/galery/00040800.jpg
// module id = 133
// module chunks = 0